let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ifK48")).then(() => parcelRequire('ggheG'));